import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdmin } from '../context/AdminContext';

/**
 * AdminProtectedRoute component
 * Ensures that routes are only accessible by authenticated admins
 * Redirects to admin login if admin is not authenticated
 */
const AdminProtectedRoute = ({ children }) => {
  const { currentAdmin, isLoading } = useAdmin();

  // While checking authentication status, show nothing or a loading indicator
  if (isLoading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  // If admin is not authenticated, redirect to admin login
  if (!currentAdmin) {
    return <Navigate to="/admin/login" />;
  }

  // If admin is authenticated, render the protected content
  return children;
};

export default AdminProtectedRoute; 